import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { PremiumPayment } from '@/types/insurance';

export function usePolicyPayments(policyId: string | undefined) {
  return useQuery({
    queryKey: ['policy-payments', policyId],
    queryFn: async (): Promise<PremiumPayment[]> => {
      const { data, error } = await supabase
        .from('insurance_premium_payments')
        .select('*')
        .eq('policy_id', policyId!)
        .order('payment_date', { ascending: false });

      if (error) throw error;
      return data as PremiumPayment[];
    },
    enabled: !!policyId,
  });
}
